export default {
    path: 'trouble_cma',
    name: 'trouble_cma',
    component: r => require.ensure([], () => r(require('./index.vue')), 'trouble_cma'),
    redirect: {name: 'trouble_cma_list'},
    children: [
        {
            path: 'trouble_cma_list',
            name: 'trouble_cma_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'trouble_cma_list'),
        }
    ]
}
